import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { ISalesTeam } from '@user/store/salesTeam'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'

type Props = {
  loadSalesTeamUsers: (value: number) => void
  name: string
}

export function useHandlers(props: Props) {
  const { loadSalesTeamUsers, name } = props
  const { setFieldValue } = useFormikContext<IAddOpportunityFormModel>()

  const currentUser = useSelector(selectCurrentUser)
  const handelChange = useCallback(
    (value: ISalesTeam | null) => {
      setFieldValue(name, value?.id ?? '')
      if (value) {
        loadSalesTeamUsers(+value.id)
        const ownerId =
          (currentUser.permissions.includes('leads_own') &&
            currentUser.salesTeamPositionsData?.salesTeamIds.includes(
              value.id,
            )) ||
          currentUser.permissions.includes('workwave_marketing_admin')
            ? currentUser.userId
            : 'unassigned'
        setFieldValue('ownerId', ownerId)
      } else {
        setFieldValue('ownerId', '')
      }
    },
    [
      currentUser.permissions,
      currentUser.salesTeamPositionsData?.salesTeamIds,
      currentUser.userId,
      loadSalesTeamUsers,
      name,
      setFieldValue,
    ],
  )

  return {
    handelChange,
  }
}
